import { render, staticRenderFns } from "./UserCheckArea.vue?vue&type=template&id=5ca5c684"
import script from "./UserCheckArea.vue?vue&type=script&lang=js"
export * from "./UserCheckArea.vue?vue&type=script&lang=js"
import style0 from "./UserCheckArea.vue?vue&type=style&index=0&id=5ca5c684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports